import { loadable } from 'utils';

export const ImportWizard = loadable(() => import('./ImportWizard'), {});
